import { config } from '../shared'

export const logout = () => location.replace(config.ssoBaseUrl.concat('/logout'))
